// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum AnchorSide {
  Top = 0,
  Bottom = 1,
  Left = 2,
  Right = 3,
  Auto = 4
}
